var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"msg":"This is Header"}}),_c('div',{staticClass:"main-view"},[_c('router-view')],1),_c('Footer',{attrs:{"msg":"This is Footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }